var CurrencyCode = /* @__PURE__ */ ((CurrencyCode2) => {
  CurrencyCode2[CurrencyCode2["AED"] = 784] = "AED";
  CurrencyCode2[CurrencyCode2["AFN"] = 971] = "AFN";
  CurrencyCode2[CurrencyCode2["ALL"] = 8] = "ALL";
  CurrencyCode2[CurrencyCode2["AMD"] = 51] = "AMD";
  CurrencyCode2[CurrencyCode2["ANG"] = 532] = "ANG";
  CurrencyCode2[CurrencyCode2["AOA"] = 973] = "AOA";
  CurrencyCode2[CurrencyCode2["ARS"] = 32] = "ARS";
  CurrencyCode2[CurrencyCode2["AUD"] = 36] = "AUD";
  CurrencyCode2[CurrencyCode2["AWG"] = 533] = "AWG";
  CurrencyCode2[CurrencyCode2["AZN"] = 944] = "AZN";
  CurrencyCode2[CurrencyCode2["BAM"] = 977] = "BAM";
  CurrencyCode2[CurrencyCode2["BBD"] = 52] = "BBD";
  CurrencyCode2[CurrencyCode2["BDT"] = 50] = "BDT";
  CurrencyCode2[CurrencyCode2["BGN"] = 975] = "BGN";
  CurrencyCode2[CurrencyCode2["BHD"] = 48] = "BHD";
  CurrencyCode2[CurrencyCode2["BIF"] = 108] = "BIF";
  CurrencyCode2[CurrencyCode2["BMD"] = 60] = "BMD";
  CurrencyCode2[CurrencyCode2["BND"] = 96] = "BND";
  CurrencyCode2[CurrencyCode2["BOB"] = 68] = "BOB";
  CurrencyCode2[CurrencyCode2["BOV"] = 984] = "BOV";
  CurrencyCode2[CurrencyCode2["BRL"] = 986] = "BRL";
  CurrencyCode2[CurrencyCode2["BSD"] = 44] = "BSD";
  CurrencyCode2[CurrencyCode2["BTN"] = 64] = "BTN";
  CurrencyCode2[CurrencyCode2["BWP"] = 72] = "BWP";
  CurrencyCode2[CurrencyCode2["BYR"] = 974] = "BYR";
  CurrencyCode2[CurrencyCode2["BZD"] = 84] = "BZD";
  CurrencyCode2[CurrencyCode2["CAD"] = 124] = "CAD";
  CurrencyCode2[CurrencyCode2["CDF"] = 976] = "CDF";
  CurrencyCode2[CurrencyCode2["CHE"] = 947] = "CHE";
  CurrencyCode2[CurrencyCode2["CHF"] = 756] = "CHF";
  CurrencyCode2[CurrencyCode2["CHW"] = 948] = "CHW";
  CurrencyCode2[CurrencyCode2["CLF"] = 990] = "CLF";
  CurrencyCode2[CurrencyCode2["CLP"] = 152] = "CLP";
  CurrencyCode2[CurrencyCode2["CNY"] = 156] = "CNY";
  CurrencyCode2[CurrencyCode2["COP"] = 170] = "COP";
  CurrencyCode2[CurrencyCode2["COU"] = 970] = "COU";
  CurrencyCode2[CurrencyCode2["CRC"] = 188] = "CRC";
  CurrencyCode2[CurrencyCode2["CUC"] = 931] = "CUC";
  CurrencyCode2[CurrencyCode2["CUP"] = 192] = "CUP";
  CurrencyCode2[CurrencyCode2["CVE"] = 132] = "CVE";
  CurrencyCode2[CurrencyCode2["CZK"] = 203] = "CZK";
  CurrencyCode2[CurrencyCode2["DJF"] = 262] = "DJF";
  CurrencyCode2[CurrencyCode2["DKK"] = 208] = "DKK";
  CurrencyCode2[CurrencyCode2["DOP"] = 214] = "DOP";
  CurrencyCode2[CurrencyCode2["DZD"] = 12] = "DZD";
  CurrencyCode2[CurrencyCode2["EGP"] = 818] = "EGP";
  CurrencyCode2[CurrencyCode2["ERN"] = 232] = "ERN";
  CurrencyCode2[CurrencyCode2["ETB"] = 230] = "ETB";
  CurrencyCode2[CurrencyCode2["EUR"] = 978] = "EUR";
  CurrencyCode2[CurrencyCode2["FJD"] = 242] = "FJD";
  CurrencyCode2[CurrencyCode2["FKP"] = 238] = "FKP";
  CurrencyCode2[CurrencyCode2["GBP"] = 826] = "GBP";
  CurrencyCode2[CurrencyCode2["GEL"] = 981] = "GEL";
  CurrencyCode2[CurrencyCode2["GHS"] = 936] = "GHS";
  CurrencyCode2[CurrencyCode2["GIP"] = 292] = "GIP";
  CurrencyCode2[CurrencyCode2["GMD"] = 270] = "GMD";
  CurrencyCode2[CurrencyCode2["GNF"] = 324] = "GNF";
  CurrencyCode2[CurrencyCode2["GTQ"] = 320] = "GTQ";
  CurrencyCode2[CurrencyCode2["GYD"] = 328] = "GYD";
  CurrencyCode2[CurrencyCode2["HKD"] = 344] = "HKD";
  CurrencyCode2[CurrencyCode2["HNL"] = 340] = "HNL";
  CurrencyCode2[CurrencyCode2["HRK"] = 191] = "HRK";
  CurrencyCode2[CurrencyCode2["HTG"] = 332] = "HTG";
  CurrencyCode2[CurrencyCode2["HUF"] = 348] = "HUF";
  CurrencyCode2[CurrencyCode2["IDR"] = 360] = "IDR";
  CurrencyCode2[CurrencyCode2["ILS"] = 376] = "ILS";
  CurrencyCode2[CurrencyCode2["INR"] = 356] = "INR";
  CurrencyCode2[CurrencyCode2["IQD"] = 368] = "IQD";
  CurrencyCode2[CurrencyCode2["IRR"] = 364] = "IRR";
  CurrencyCode2[CurrencyCode2["ISK"] = 352] = "ISK";
  CurrencyCode2[CurrencyCode2["JMD"] = 388] = "JMD";
  CurrencyCode2[CurrencyCode2["JOD"] = 400] = "JOD";
  CurrencyCode2[CurrencyCode2["JPY"] = 392] = "JPY";
  CurrencyCode2[CurrencyCode2["KES"] = 404] = "KES";
  CurrencyCode2[CurrencyCode2["KGS"] = 417] = "KGS";
  CurrencyCode2[CurrencyCode2["KHR"] = 116] = "KHR";
  CurrencyCode2[CurrencyCode2["KMF"] = 174] = "KMF";
  CurrencyCode2[CurrencyCode2["KPW"] = 408] = "KPW";
  CurrencyCode2[CurrencyCode2["KRW"] = 410] = "KRW";
  CurrencyCode2[CurrencyCode2["KWD"] = 414] = "KWD";
  CurrencyCode2[CurrencyCode2["KYD"] = 136] = "KYD";
  CurrencyCode2[CurrencyCode2["KZT"] = 398] = "KZT";
  CurrencyCode2[CurrencyCode2["LAK"] = 418] = "LAK";
  CurrencyCode2[CurrencyCode2["LBP"] = 422] = "LBP";
  CurrencyCode2[CurrencyCode2["LKR"] = 144] = "LKR";
  CurrencyCode2[CurrencyCode2["LRD"] = 430] = "LRD";
  CurrencyCode2[CurrencyCode2["LSL"] = 426] = "LSL";
  CurrencyCode2[CurrencyCode2["LTL"] = 440] = "LTL";
  CurrencyCode2[CurrencyCode2["LVL"] = 428] = "LVL";
  CurrencyCode2[CurrencyCode2["LYD"] = 434] = "LYD";
  CurrencyCode2[CurrencyCode2["MAD"] = 504] = "MAD";
  CurrencyCode2[CurrencyCode2["MDL"] = 498] = "MDL";
  CurrencyCode2[CurrencyCode2["MGA"] = 969] = "MGA";
  CurrencyCode2[CurrencyCode2["MKD"] = 807] = "MKD";
  CurrencyCode2[CurrencyCode2["MMK"] = 104] = "MMK";
  CurrencyCode2[CurrencyCode2["MNT"] = 496] = "MNT";
  CurrencyCode2[CurrencyCode2["MOP"] = 446] = "MOP";
  CurrencyCode2[CurrencyCode2["MRO"] = 478] = "MRO";
  CurrencyCode2[CurrencyCode2["MUR"] = 480] = "MUR";
  CurrencyCode2[CurrencyCode2["MVR"] = 462] = "MVR";
  CurrencyCode2[CurrencyCode2["MWK"] = 454] = "MWK";
  CurrencyCode2[CurrencyCode2["MXN"] = 484] = "MXN";
  CurrencyCode2[CurrencyCode2["MXV"] = 979] = "MXV";
  CurrencyCode2[CurrencyCode2["MYR"] = 458] = "MYR";
  CurrencyCode2[CurrencyCode2["MZN"] = 943] = "MZN";
  CurrencyCode2[CurrencyCode2["NAD"] = 516] = "NAD";
  CurrencyCode2[CurrencyCode2["NGN"] = 566] = "NGN";
  CurrencyCode2[CurrencyCode2["NIO"] = 558] = "NIO";
  CurrencyCode2[CurrencyCode2["NOK"] = 578] = "NOK";
  CurrencyCode2[CurrencyCode2["NPR"] = 524] = "NPR";
  CurrencyCode2[CurrencyCode2["NZD"] = 554] = "NZD";
  CurrencyCode2[CurrencyCode2["OMR"] = 512] = "OMR";
  CurrencyCode2[CurrencyCode2["PAB"] = 590] = "PAB";
  CurrencyCode2[CurrencyCode2["PEN"] = 604] = "PEN";
  CurrencyCode2[CurrencyCode2["PGK"] = 598] = "PGK";
  CurrencyCode2[CurrencyCode2["PHP"] = 608] = "PHP";
  CurrencyCode2[CurrencyCode2["PKR"] = 586] = "PKR";
  CurrencyCode2[CurrencyCode2["PLN"] = 985] = "PLN";
  CurrencyCode2[CurrencyCode2["PYG"] = 600] = "PYG";
  CurrencyCode2[CurrencyCode2["QAR"] = 634] = "QAR";
  CurrencyCode2[CurrencyCode2["RON"] = 946] = "RON";
  CurrencyCode2[CurrencyCode2["RSD"] = 941] = "RSD";
  CurrencyCode2[CurrencyCode2["RUB"] = 643] = "RUB";
  CurrencyCode2[CurrencyCode2["RWF"] = 646] = "RWF";
  CurrencyCode2[CurrencyCode2["SAR"] = 682] = "SAR";
  CurrencyCode2[CurrencyCode2["SBD"] = 90] = "SBD";
  CurrencyCode2[CurrencyCode2["SCR"] = 690] = "SCR";
  CurrencyCode2[CurrencyCode2["SDG"] = 938] = "SDG";
  CurrencyCode2[CurrencyCode2["SEK"] = 752] = "SEK";
  CurrencyCode2[CurrencyCode2["SGD"] = 702] = "SGD";
  CurrencyCode2[CurrencyCode2["SHP"] = 654] = "SHP";
  CurrencyCode2[CurrencyCode2["SLL"] = 694] = "SLL";
  CurrencyCode2[CurrencyCode2["SOS"] = 706] = "SOS";
  CurrencyCode2[CurrencyCode2["SRD"] = 968] = "SRD";
  CurrencyCode2[CurrencyCode2["SSP"] = 728] = "SSP";
  CurrencyCode2[CurrencyCode2["STD"] = 678] = "STD";
  CurrencyCode2[CurrencyCode2["SVC"] = 222] = "SVC";
  CurrencyCode2[CurrencyCode2["SYP"] = 760] = "SYP";
  CurrencyCode2[CurrencyCode2["SZL"] = 748] = "SZL";
  CurrencyCode2[CurrencyCode2["THB"] = 764] = "THB";
  CurrencyCode2[CurrencyCode2["TJS"] = 972] = "TJS";
  CurrencyCode2[CurrencyCode2["TMT"] = 934] = "TMT";
  CurrencyCode2[CurrencyCode2["TND"] = 788] = "TND";
  CurrencyCode2[CurrencyCode2["TOP"] = 776] = "TOP";
  CurrencyCode2[CurrencyCode2["TRY"] = 949] = "TRY";
  CurrencyCode2[CurrencyCode2["TTD"] = 780] = "TTD";
  CurrencyCode2[CurrencyCode2["TWD"] = 901] = "TWD";
  CurrencyCode2[CurrencyCode2["TZS"] = 834] = "TZS";
  CurrencyCode2[CurrencyCode2["UAH"] = 980] = "UAH";
  CurrencyCode2[CurrencyCode2["UGX"] = 800] = "UGX";
  CurrencyCode2[CurrencyCode2["USD"] = 840] = "USD";
  CurrencyCode2[CurrencyCode2["USN"] = 997] = "USN";
  CurrencyCode2[CurrencyCode2["USS"] = 998] = "USS";
  CurrencyCode2[CurrencyCode2["UYI"] = 940] = "UYI";
  CurrencyCode2[CurrencyCode2["UYU"] = 858] = "UYU";
  CurrencyCode2[CurrencyCode2["UZS"] = 860] = "UZS";
  CurrencyCode2[CurrencyCode2["VEF"] = 937] = "VEF";
  CurrencyCode2[CurrencyCode2["VND"] = 704] = "VND";
  CurrencyCode2[CurrencyCode2["VUV"] = 548] = "VUV";
  CurrencyCode2[CurrencyCode2["WST"] = 882] = "WST";
  CurrencyCode2[CurrencyCode2["XAF"] = 950] = "XAF";
  CurrencyCode2[CurrencyCode2["XAG"] = 961] = "XAG";
  CurrencyCode2[CurrencyCode2["XAU"] = 959] = "XAU";
  CurrencyCode2[CurrencyCode2["XBA"] = 955] = "XBA";
  CurrencyCode2[CurrencyCode2["XBB"] = 956] = "XBB";
  CurrencyCode2[CurrencyCode2["XBC"] = 957] = "XBC";
  CurrencyCode2[CurrencyCode2["XBD"] = 958] = "XBD";
  CurrencyCode2[CurrencyCode2["XCD"] = 951] = "XCD";
  CurrencyCode2[CurrencyCode2["XDR"] = 960] = "XDR";
  CurrencyCode2[CurrencyCode2["XOF"] = 952] = "XOF";
  CurrencyCode2[CurrencyCode2["XPD"] = 964] = "XPD";
  CurrencyCode2[CurrencyCode2["XPF"] = 953] = "XPF";
  CurrencyCode2[CurrencyCode2["XPT"] = 962] = "XPT";
  CurrencyCode2[CurrencyCode2["XTS"] = 963] = "XTS";
  CurrencyCode2[CurrencyCode2["XXX"] = 999] = "XXX";
  CurrencyCode2[CurrencyCode2["YER"] = 886] = "YER";
  CurrencyCode2[CurrencyCode2["ZAR"] = 710] = "ZAR";
  CurrencyCode2[CurrencyCode2["ZMK"] = 894] = "ZMK";
  CurrencyCode2[CurrencyCode2["ZMW"] = 967] = "ZMW";
  CurrencyCode2[CurrencyCode2["BTC"] = 1001] = "BTC";
  CurrencyCode2[CurrencyCode2["XUS"] = 1002] = "XUS";
  CurrencyCode2[CurrencyCode2["SLE"] = 925] = "SLE";
  return CurrencyCode2;
})(CurrencyCode || {});
export {
  CurrencyCode
};
//# sourceMappingURL=currency-codes.js.map
